import { useCallback, useEffect, useMemo, useState } from 'react';
import LogsScreen from '../LogsScreen';
import LogsFilter from '../Filter';
import useRequest from '../../../../../hooks/useRequest';
import ServicePaths from '../../../../../bridge/utils/ServicePaths';
import { Bot } from '../../../../Detail/types';
import { useErrorLogsWebsocket } from '../../../../../hooks/useErrorLogsWebsocket';

const ErrorLogs = () => {
  const { data: botsData } = useRequest(ServicePaths.DATA.GetAllActiveBots);

  const botIds = useMemo(() => {
    if (!botsData?.bots?.length) {
      return [];
    }

    return (botsData?.bots as Bot[]).map((b) => b.botId);
  }, [botsData?.bots]);

  const [activeBot, setActiveBots] = useState<Bot | undefined>();

  const handleBoCchange = useCallback(
    (botId: string) => {
      setActiveBots(botsData?.bots.find((b: Bot) => b.botId === botId));
    },
    [botsData?.bots],
  );

  useEffect(() => {
    if (!botsData?.bots?.length) {
      return;
    }

    setActiveBots(botsData?.bots[0]);
  }, [botsData?.bots]);

  const [searchQuery, setSearchQuery] = useState('');

  const [startTimestamp, setStartTimestamp] = useState<string | undefined>();
  const [endTimestamp, setEndTimestamp] = useState<string | undefined>();

  const amountOfLogs = [200, 500, 1000, 2000, 5000];
  const [maxLogs, setMaxLogs] = useState(amountOfLogs[0]);

  const { logRecords, isLoading } = useErrorLogsWebsocket();

  return (
    <div
      style={{
        margin: 20,
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <LogsFilter
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        maxLogs={maxLogs}
        setMaxLogs={setMaxLogs}
        amountOfLogs={amountOfLogs}
        startTimestamp={startTimestamp}
        setStartTimestamp={setStartTimestamp}
        endTimestamp={endTimestamp}
        setEndTimestamp={setEndTimestamp}
      />

      <LogsScreen
        id={'ALL'}
        logRecords={logRecords}
        isLoading={isLoading}
        maxLogs={maxLogs}
      />
    </div>
  );
};

export default ErrorLogs;
